import React from 'react';
import HPLatestPublished from './HPLatestPublished';

const View = () => <HPLatestPublished />;

export default View;